import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { number, object } from "yup";
import PURCHASEIRQPropertyValueView from "../views/IrqPropertyValueView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqPropertyValuePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            price: number().positive().integer().required(),
          })}
        >
          <PURCHASEIRQPropertyValueView
            content={contentMap.RefinanceIrqPropertyValuePage}
            navigationsAway={customNavigationMap.RefinanceIrqPropertyValuePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqPropertyValuePage);
